import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import articlePage from "@faire/web-api--source/routes/support/articles/articleId";

import { InstantAnswerContext, InstantAnswerScenario } from "../../types";

export const WhyOrderCancelledIA: InstantAnswerBuilderFn = (
  strictLocalize,
  articles
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    learnMoreLink: articles?.Account.NOT_OPEN
      ? articlePage(articles.Account.NOT_OPEN.id)
      : undefined,
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => VERIFY_YOUR_ACCOUNT(strictLocalize),
    getDescription: () => [
      WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize),
      IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize),
    ],
  };
};

const VERIFY_YOUR_ACCOUNT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Accounts must be verified to receive orders from brands on Faire",
    description: {
      text: "Title for the answer of Why is my order cancelled issue",
    },
  });

const WE_VERIFY_ALL_NEW_ACCOUNTS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "We verify all new accounts to maintain a safe marketplace. If your account can’t be verified, any existing orders will be canceled — you won’t be charged.",
  });

const IF_YOU_HAVE_ANY_QUESTIONS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "If you have any questions, continue to contact us and we’ll get back to you as soon as possible.",
  });
